import { Moment } from 'moment';
import { OperacaoCompraVendaCompromissadaRequest } from 'common/genericTypes';
import { stripCpfCnpjFormatting } from 'utils/validation';

export interface CompromissadaRequestInput {
  quantidade: number;
  operacaoCodigo: string;
  precoUnitario: number;
  custodianteDestinoId: string;
  contaDepositoDestino: string;
  indexador?: string | null;
  indexadorPorcentagem?: number | null;
  taxaDeJuros?: number | null;
  dataDeRetorno?: Moment | null;
  custodianteOrigemCnpj: string;
  investidorCpfCnpjLimpo: string;
  contaDepositoOrigem?: string | null;
  custodianteDestinoCnpj: string;
}

const LIQUIDACAO_SEMPRE_DIRETA = true;

export const buildCompromissadaRequest = (
  input: CompromissadaRequestInput
): OperacaoCompraVendaCompromissadaRequest => ({
  Quantidade: input.quantidade,
  OperacaoCodigo: input.operacaoCodigo,
  PrecoUnitario: input.precoUnitario,
  CustodianteDestinoId: input.custodianteDestinoId,
  ContaDepositoDestino: input.contaDepositoDestino,
  LiquidacaoDireta: LIQUIDACAO_SEMPRE_DIRETA,
  Indexador: input.indexador ?? '',
  IndexadorPorcentagem: input.indexadorPorcentagem ?? 0,
  TaxaDeJuros: input.taxaDeJuros ?? 0,
  DataDeRetorno: input.dataDeRetorno?.toISOString() ?? null,
  PuDeRetorno: 0,
  Origem: {
    CustodianteCnpj: input.custodianteOrigemCnpj,
    CpfCnpjInvestidor: input.investidorCpfCnpjLimpo,
    ContaDepositoOrigem: input.contaDepositoOrigem ?? '',
  },
  Destino: {
    CustodianteCnpj: stripCpfCnpjFormatting(input.custodianteDestinoCnpj),
    ContaDepositoDestino: input.contaDepositoDestino,
  },
});
